import { render, staticRenderFns } from "./SuggestItem.vue?vue&type=template&id=412823c1&scoped=true&"
import script from "./SuggestItem.vue?vue&type=script&lang=js&"
export * from "./SuggestItem.vue?vue&type=script&lang=js&"
import style0 from "./SuggestItem.vue?vue&type=style&index=0&id=412823c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412823c1",
  null
  
)

export default component.exports